import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gt-errors-page" }
const _hoisted_2 = { class: "g-row g-row--align_center g-row--space_none g-row--appearance_column" }
const _hoisted_3 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_4 = { class: "gt-errors-page-alert-icon" }
const _hoisted_5 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_6 = { class: "ds-caption ds-caption--size_2xl ds-caption--bold" }
const _hoisted_7 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_8 = { class: "ds-caption ds-caption--size_xl ds-caption--semibold ds-caption--appearance_center" }
const _hoisted_9 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_10 = { class: "gt-space_mt gt-space_mt--6" }
const _hoisted_11 = {
  class: "gt-button gt-button--trans",
  href: "/",
  target: "_self"
}
const _hoisted_12 = { class: "gt-button__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_alert = _resolveComponent("i-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "g-cell g-cols g-cols--narrow" }, [
        _createElementVNode("img", {
          class: "gt-errors-page-logo",
          src: "/static/app/gt-auth-logo.svg",
          alt: "tt-logo-image"
        })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_i_alert)
        ])
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "g-cell g-cols g-cols--narrow" }, [
        _createElementVNode("p", { class: "ds-caption ds-caption--size_4xl ds-caption--bold ds-caption--color_accent" }, _toDisplayString("403"))
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString($setup.$t('Access is denied')), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("p", _hoisted_8, _toDisplayString($setup.$t('Sorry, you do not have access to this page.')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString($setup.isAuth ? $setup.$t('Profile') : $setup.$t('Authorization')), 1)
          ])
        ])
      ])
    ])
  ]))
}